const WhoCaptionBuilder = require('../routines/utilities/WhoCaptionBuilder');

class IssueAssigneeCaptionBuilder {
   constructor() {
      this.whoCaptionBuilder = new WhoCaptionBuilder();
   }

   build(args) {
      const caption = this.whoCaptionBuilder.build(args);
      const { who } = args;
      const teamCount = who.teams && who.teams.length ? who.teams.length : 0;
      const positionCount = who.positions && who.positions.length ? who.positions.length : 0;
      const staffCount = who.staff && who.staff.length ? who.staff.length : 0;
      const targetCount = teamCount + positionCount + staffCount;

      if (targetCount !== 1) {
         return caption;
      }

      if (teamCount === 1) {
         return caption.replace(/^Any one on the /, '');
      }

      if (positionCount === 1) {
         return caption.replace(/^Any one in the /, '');
      }

      return caption;
   }
}

module.exports = IssueAssigneeCaptionBuilder;
